import { render, staticRenderFns } from "./buyerMessage.vue?vue&type=template&id=9a43bcd6&"
import script from "./buyerMessage.vue?vue&type=script&lang=js&"
export * from "./buyerMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports